'use strict';

var _ = require('lodash');
var Analytics = require('./Analytics');

var AnalyticsProvider = function () {
  
  var config = this;
  var defaults = {
    segmentIO: {
      options: {
        flushAt: 10,
        flushAfter: 5000
      },
      writeKey: '6Hv62zUZIP7Yw1IO8ddaqs6zL61SpMjJ' // Commander Dev Write Key
    }
  };

  // Configuration GETTER function that can be set by the application. It will
  // be passed the default configurations.
  this.configGetter = function () {
    return defaults;
  }

  this.$get = function ($injector, $q, $window) {
    var configPromise = $q.resolve($injector.invoke(config.configGetter, this, {
      defaults: defaults
    }));
    
    return new Analytics($injector, $q, $window, configPromise);
  };
  
  this.$get.$inject = ['$injector', '$q', '$window'];
};

module.exports = AnalyticsProvider;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/analytics/src/AnalyticsProvider.js